



































import Component from 'vue-class-component';
import Vue from 'vue';
import Top10Criteria from './top10-criteria.vue';
import Top10Table from '@/components/stats/top10-table.vue';
import * as ent from '@/entities';
import statsApi from '@/api/stats.api';
import {formatDateWithTime, parseDate} from '@/utils';
import {GroupBy} from '@/entities';

@Component({
    components: {
        'top10-criteria': Top10Criteria,
        'top10-table': Top10Table
    }
})
export default class Top10Agents extends Vue {
    public items: ent.IStatTop10ItemModel[] = null;
    public loading: boolean = false;
    public criteriaStr: string = '';
    public printVersion = false;
    public groupBy: GroupBy = null;

    public async search(body: ent.IGetTop10StatsModel) {
        this.groupBy = body.groupBy;
        this.loading = true;
        this.items = null;
        try {
            this.items = await statsApi.top10(body);
            this.criteriaStr = `The Period (From ${body.start} To ${body.end})`;
        } finally {
            this.loading = false;
        }
    }

    private get showAgentColumn(): boolean {
        return this.groupBy === GroupBy.Agent;
    }

    private togglePrintVersion() {
        this.printVersion = !this.printVersion;
    }
}
